// BKT-1514: tipo do índice econômico — o valor gravado continua o nome do enum da API (IPCA, IGPM, IGMP);
// só o texto exibido muda (IGPM → "IGP-M"). A API devolve o enum como número, na ordem abaixo.
const TIPOS_INDICE = ["IPCA", "IGMP", "IGPM"];
const TIPO_INDICE_LEGADO = "IGMP";

const DESCRICOES_TIPO_INDICE = {
    IPCA: "IPCA",
    IGPM: "IGP-M",
    IGMP: "IGMP (legado)",
};

// 0/1/2 (ou "0"/"1"/"2") → nome do enum; nomes passam como estão
const normalizarTipoIndice = (valor) => {
    if (valor === null || valor === undefined || valor === "")
        return valor;
    if (typeof valor === "number" || /^\d+$/.test(String(valor)))
        return TIPOS_INDICE[Number(valor)] || String(valor);
    return String(valor);
};

const descricaoTipoIndice = (valor) => {
    const tipo = normalizarTipoIndice(valor);
    return DESCRICOES_TIPO_INDICE[tipo] || tipo;
};

// Opções do select a partir de api/IndiceEconomico/getTiposIndiceDescricao ([{ valor, descricao }]).
// O IGMP legado só aparece ao editar um índice que já é IGMP — novos cadastros usam IGP-M.
const opcoesTipoIndice = (tipos, valorAtual) => {
    const atual = normalizarTipoIndice(valorAtual);
    return (tipos || [])
        .filter(t => t && (t.valor !== TIPO_INDICE_LEGADO || atual === TIPO_INDICE_LEGADO))
        .map(t => ({ label: t.descricao || descricaoTipoIndice(t.valor), value: t.valor }));
};

export {
    normalizarTipoIndice,
    descricaoTipoIndice,
    opcoesTipoIndice,
};
